export default __webpack_public_path__ + "static/media/PL001.70f2b8c9.mp3";